var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoorders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 243.4 213.9",
    style: {
      enableBackground: "new 0 0 243.4 213.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ACEBE9;}\n\t.st1{fill:#98EAE5;}\n\t.st2{fill:#4B4495;}\n\t.st3{fill:#92E2E9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000123409161798442550420000005092366750914195868_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.9,197.9l-119.5,16V87.8L212.2,71C212.4,113.3,212.7,155.6,212.9,197.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "93.4,213.9 28.7,180.5 28.7,51.2 93.4,87.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "62.7,124.6 0,87.2 28.7,51.2 93.4,87.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "123.9,127 242.2,106.8 212.2,71 93.4,87.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.8,36v44c-18.1,2.6-36.3,5.1-54.4,7.7C71.9,75.5,50.3,63.3,28.8,51.1L147.8,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.2,71l-64.4-35v44L212.2,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.3,1.8l66,34.5L212.2,71l-64.4-34.9C157.7,24.6,167.5,13.2,177.3,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.8,13.9L121.6,0c8.7,12,17.5,24,26.2,36c-39.7,5.1-79.4,10.1-119.1,15.2L2.8,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.7,147.6c0,3.7-2.6,7-6.3,7.6c-3.5,0.5-6.3-2.2-6.3-6c0-3.7,2.6-6.9,6.3-7.6 C126.9,141.1,129.7,143.8,129.7,147.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192.5,139.2c0,3.8-2.8,7.3-6.3,7.8s-6.3-2.3-6.3-6.1s2.8-7.3,6.3-7.8S192.5,135.4,192.5,139.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.7,186.4c-1.3,0-2.4-1-2.5-2.4c-0.5-10.3,7.3-20.1,16.8-20.9c4.2-0.4,8.1,1.1,11.2,4 c3.5,3.3,5.3,8.3,5.1,13.5c-0.1,1.4-1.2,2.4-2.6,2.4c-1.4-0.1-2.4-1.2-2.4-2.6c0.2-3.8-1.1-7.4-3.5-9.7c-2-1.9-4.6-2.9-7.3-2.6 c-6.8,0.6-12.6,8.1-12.2,15.7c0.1,1.4-1,2.6-2.4,2.6C146.8,186.4,146.8,186.4,146.7,186.4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoorders);
export default __webpack_public_path__ + "static/media/No orders.9e45f647b506e5ee90343406b073aefa.svg";
export { ForwardRef as ReactComponent };